import axios from '../../../axios/index'
import { API_URL, BASE_URL } from "../../../axios/config";
import { GET_INVOICE_DOWNLOAD_DATA } from "../../constants/invoice/Invoice";
import { call, put, takeLatest } from "@redux-saga/core/effects";
import { downloadInvoiceSuccess } from '../../actions/downloadInvoice/DownloadInvoice';

async function downloadInvoiceAPI(data) {
    return axios.request({
            method: "post",
            url: BASE_URL + API_URL.DOWNLOAD_INVOICE,
            params: data
    });
}

function* downloadInvoiceAction(action) {
    let { payload, resolve, reject } = action;
    try {
        let response = yield call(downloadInvoiceAPI,payload);
        if (response.status === 200) {
            if (response.data.success) {
                yield put(downloadInvoiceSuccess(response.data));
            }
            else {
            }
            if (resolve) resolve(response);
        } else {
            yield put((response));
            if (reject) reject(response);
        }
    } catch (error) {
        // yield put(setLoaderComplete());
        if (reject) reject(error);
    }
}

export function* invoiceDownloadWatcher() {
    yield takeLatest(GET_INVOICE_DOWNLOAD_DATA, downloadInvoiceAction);
}